// Centralized configuration for the application

// Determine the API base URL based on the environment or use a default
// You can easily switch this for production
//const API_BASE_URL = "http://127.0.0.1:8000";
// const API_BASE_URL = "https://tuberoid-impercipient-ivelisse.ngrok-free.dev";
const API_BASE_URL = "https://taxibcnaeropuerto.com";
export const config = {
    API_BASE_URL,
    // Add other global config constants here if needed
};
